module.exports = __webpack_public_path__ + "img/leaf.7ac4c4c4.png";